import { render } from "./TestButtonsPage.vue?vue&type=template&id=10601299"
import script from "./TestButtonsPage.vue?vue&type=script&lang=js"
export * from "./TestButtonsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__